import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/recalls')({
  component: RecallsLayout,
});

function RecallsLayout() {
  return <Outlet />;
}
